<template>
    <div class="columns">
        <div class="column is-3 vertical-text">
            <p>{{ startHour }}</p>
        </div>
        <div class="column is-3 vertical-text">
            {{ duration }} {{ $t("active-rooms.minutes") }}
        </div>
        <div class="column is-6 vertical-text">{{ description }}</div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "active-room",
    props: {
        room: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            duration: 0,
        };
    },
    mounted() {
        this.updateDuration();
        setInterval(this.updateDuration, 1000);
    },
    computed: {
        startHour() {
            let date = moment(this.room.startDate);
            return date.format("HH:mm");
        },
        description() {
            return this.room.description;
        },
    },
    methods: {
        updateDuration() {
            let now = moment();
            let startDate = moment(this.room.startDate);
            this.duration = now.diff(startDate, "minutes");
        },
    },
};
</script>